import React from 'react';
import { FormattedMessage } from 'react-intl';

import InvoiceLookupContent from './InvoiceLookupContent';
import NewShipmentDrawer from '../../components/drawers/NewShipmentDrawer';
import { useInvoiceStyles } from './invoice.styles';

export default function InvoiceLookupDrawer({ open, onClose }) {
  const { styles } = useInvoiceStyles();
  return (
    <NewShipmentDrawer
      className={styles.drawer}
      header={<FormattedMessage id="account.invoice" />}
      open={open}
      onClose={onClose}
    >
      <InvoiceLookupContent onClose={onClose} />
    </NewShipmentDrawer>
  );
}
